import React, { useState } from 'react';
import { Box, Typography, TextField, Button, CircularProgress, Grid, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { useAuth } from '../../AuthProvider';
import { toast ,ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); // State for field errors
  const { loginEmail } = useAuth();

  console.log("ChangePassword email:", loginEmail);

  const validateFields = () => {
    let tempErrors = {};
    if (!oldPassword) tempErrors.oldPassword = "Old Password is required";
    if (!newPassword) tempErrors.newPassword = "New Password is required";
    if (!confirmPassword) tempErrors.confirmPassword = "Confirm Password is required";
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // const handleChangePassword = async () => {
  //   if (!validateFields()) return; // Stop execution if validation fails

  //   setLoading(true);
  //   try {
  //     const baseUrl = process.env.REACT_APP_API_BASE_URL;
  //     const url = `${baseUrl}/api/users/change-password?input=${loginEmail}&oldPassword=${oldPassword}&newPassword=${newPassword}&confirmPassword=${confirmPassword}`;
      
  //     const response = await fetch(url, {
  //       method: 'PUT',
  //       headers: { 'Content-Type': 'application/json' },
  //     });

  //     const result = response.headers.get('content-type')?.includes('application/json') 
  //       ? await response.json() 
  //       : await response.text();

  //     if (response.ok) {
  //       Swal.fire({ icon: 'success', title: 'Password Changed', text: 'Your password has been changed successfully.' });
  //       setOldPassword('');
  //       setNewPassword('');
  //       setConfirmPassword('');
  //       setErrors({});
  //     } else {
  //       Swal.fire({ icon: 'error', title: 'Error', text: result || 'There was a problem changing your password.' });
  //     }
  //   } catch (error) {
  //     console.error('Error changing password:', error);
  //     Swal.fire({ icon: 'error', title: 'Error', text: 'There was a problem changing your password. Please try again later.' });
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleChangePassword = async () => {
    if (!validateFields()) return; // Stop execution if validation fails
  
    setLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const url = `${baseUrl}/api/users/change-password?input=${loginEmail}&oldPassword=${oldPassword}&newPassword=${newPassword}&confirmPassword=${confirmPassword}`;
      
      const response = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
      });
  
      const result = response.headers.get('content-type')?.includes('application/json') 
        ? await response.json() 
        : await response.text();
  
      if (response.ok) {
        // ✅ Success toast (auto-close after 1 sec)
        toast.success("Password changed successfully!", {
          position: "top-right",
          autoClose: 1000, 
        });
  
        // ✅ Clear fields after success
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setErrors({});
      } else {
        // ❌ Error toast (auto-close after 2 sec)
        toast.error(result || "There was a problem changing your password.", {
          position: "top-right",
          autoClose: 2000, 
        });
      }
    } catch (error) {
      console.error("Error changing password:", error);
  
      // ❌ Show error toast (auto-close after 2 sec)
      toast.error("There was a problem changing your password. Please try again later.", {
        position: "top-right",
        autoClose: 2000, 
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ 
      margin: '8% 1% 1% 1%',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      backgroundColor: 'white',
      
      borderRadius: '8px',
      maxWidth: '500px',
      marginLeft: 'auto',
      marginRight: 'auto'
    }}>
      {/* Title */}
      <Typography 
        variant="h3" 
        sx={{ padding: '5px 10px 10px 10px', fontWeight: 'bold' }}
      >
        Change Password
      </Typography>

      {/* Inputs displayed one below the other */}
      <Grid container spacing={2} direction="column" sx={{padding: '20px',}}>
        <Grid item>
          <TextField
            fullWidth
            label="Old Password"
            variant="outlined"
            type={showOldPassword ? 'text' : 'password'}
            value={oldPassword}
            onChange={(e) => {
              setOldPassword(e.target.value);
              setErrors((prev) => ({ ...prev, oldPassword: '' }));
            }}
            error={!!errors.oldPassword}
            helperText={errors.oldPassword}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowOldPassword(!showOldPassword)}>
                  {showOldPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              )
            }}
          />
        </Grid>
        <Grid item>
          <TextField
            fullWidth
            label="New Password"
            variant="outlined"
            type={showNewPassword ? 'text' : 'password'}
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              setErrors((prev) => ({ ...prev, newPassword: '' }));
            }}
            error={!!errors.newPassword}
            helperText={errors.newPassword}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowNewPassword(!showNewPassword)}>
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              )
            }}
          />
        </Grid>
        <Grid item>
          <TextField
            fullWidth
            label="Confirm Password"
            variant="outlined"
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setErrors((prev) => ({ ...prev, confirmPassword: '' }));
            }}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              )
            }}
          />
        </Grid>
      </Grid>

      {/* Button */}
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
        <Button
          variant="contained"
          onClick={handleChangePassword}
          disabled={loading}
          sx={{
            width: '200px',
            fontWeight: 'bold',
            marginBottom: '20px' ,
            backgroundColor: '#3C3972',
            color: '#fff',
            '&:hover': { backgroundColor: '#3C3972' }
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Change Password'}
        </Button>
      </Box>
      <ToastContainer />
    </Box>
  );
};

export default ChangePassword;
